const pageLinksData = [
  { type: "standalone", innerHTML: "HOME", href: "/" },
  {
    type: "dropdown",
    innerHTML: "FEATURES",
    items: [
      {
        innerHTML: "FEATURE LIST",
        href: "/features/",
      },
      {
        innerHTML: "SUPPORTED APPS",
        href: "/apps/",
      },
    ]
  },
  { type: "standalone", innerHTML: "FAQ", href: "/faqs/" },
  { type: "standalone", innerHTML: "PLANS", href: "/pricing/" },
  {
    type: "dropdown",
    innerHTML: "ABOUT",
    items: [
      {
        innerHTML: "WHO WE ARE",
        href: "/who-we-are/",
      },
      {
        innerHTML: "WHAT WE DO",
        href: "/what-we-do/",
      },
      {
        innerHTML: "SMALL AND MEDIUM BUSINESS",
        href: "/small-med-business/",
      },
      {
        innerHTML: "BLOG",
        href: "https://blog.engineid.com/",
      },
    ],
  },
  { type: "standalone", innerHTML: "CONTACT", href: "/contact-us/" },
  {
    type: "dropdown",
    innerHTML: "APP",
    items: [
      {
        innerHTML: "SIGN IN",
        href: "https://app.engineid.com/",
      },
      {
        innerHTML: "REGISTER",
        href: "https://app.engineid.com/register",
      },
      // {
      //   innerHTML: "MOBILE APP",
      //   href: "/mobile-apps/",
      // },
    ]
  },
]

export default pageLinksData
